/** How the Plan and Usage pages name a plan's dates and where the org stands. */
import type { Plan, State } from "../../api/types.gen.ts";
import { type Key, t } from "../../i18n/index.ts";
import { formatInstant } from "../../lib/format.ts";
import type { Tone } from "../../ui/styles.ts";

/** Dates as these pages write them ("April 30, 2027"), in the viewer's locale and zone. */
export const DATE: Intl.DateTimeFormatOptions = { dateStyle: "long" };

/** When the plan renews or ends. */
export function planDates(plan: Plan): string | null {
  if (!plan.expires_at) {
    return plan.invoiced ? t("billing.byInvoice") : null;
  }
  const at = formatInstant(plan.expires_at, DATE);
  return t(plan.invoiced ? "billing.until" : plan.renews ? "billing.renews" : "billing.ends", { at });
}

/** Each state's badge: its name and tone. */
export const STATES: Record<State, [Key, Tone]> = {
  trial: ["plan.state.trial", "blue"],
  active: ["plan.state.active", "green"],
  past_due: ["plan.state.past_due", "amber"],
  grace: ["plan.state.grace", "amber"],
  suspended: ["plan.state.suspended", "red"],
};
